import Button from '@mui/material/Button'
import { ButtonProps } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'
import React, { useState } from 'react'

interface LoadingButtonProps extends ButtonProps {
    onClickAsync?: () => Promise<void>
}

export const LoadingButton: React.FC<LoadingButtonProps> = ({
    onClickAsync,
    children,
    ...rest
}) => {
    const [loading, setLoading] = useState(false)

    const handleClick = async () => {
        if (!onClickAsync) return

        try {
            setLoading(true)
            await onClickAsync()
        } finally {
            setLoading(false)
        }
    }

    return (
        <Button
            {...rest}
            onClick={handleClick}
            disabled={loading || rest.disabled}
            startIcon={
                loading ? (
                    <CircularProgress size={20} color="inherit" />
                ) : (
                    rest.startIcon
                )
            }
        >
            {children}
        </Button>
    )
}
